import { render, staticRenderFns } from "./ProviderSignUp.vue?vue&type=template&id=0dcd5c06&scoped=true&"
import script from "./ProviderSignUp.vue?vue&type=script&lang=js&"
export * from "./ProviderSignUp.vue?vue&type=script&lang=js&"
import style0 from "./ProviderSignUp.vue?vue&type=style&index=0&id=0dcd5c06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcd5c06",
  null
  
)

export default component.exports